module.exports = __webpack_public_path__ + "static/assets/43e305d1093810ec72df0c0d10f3b8c8.svg";